// extracted by mini-css-extract-plugin
export default {"social-menu":"MlDb6G3X94gjax9KO9Yl","icon":"ht6h5RvYv7oh5Ewh0NZi"};